import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { useTheme } from "@emotion/react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  valuesFormReservationGuestState,
  valuesFormReservationUserState,
} from "src/Patient/state/atoms";
import TabsCustom from "src/shared/components/tabs/TabsCustom";
import FormLogin from "./FormLogin";
import FormWaitListGuest from "./FormWaitListGuest";
import { activeTabReservationState } from "src/Reservation/state/atoms";

export default function TabsWaitList() {
  const [activeTabReservation, setActiveTabReservation] = useRecoilState(
    activeTabReservationState
  );
  const theme = useTheme();
  const valuesFormReservationGuest = useRecoilValue(
    valuesFormReservationGuestState
  );
  const valuesFormReservationUser = useRecoilValue(
    valuesFormReservationUserState
  );

  const [tabsDisabled, setTabsDisabled] = useState({
    one: false,
    two: false,
  });

  const handleChangeTab = (event, newValue) => {
    setActiveTabReservation(newValue);
  };

  useEffect(() => {
    if (Object.values(valuesFormReservationGuest).some((x) => x !== "")) {
      setTabsDisabled({
        ...tabsDisabled,
        one: true,
      });
    } else {
      setTabsDisabled({
        ...tabsDisabled,
        one: false,
      });
    }
  }, [valuesFormReservationGuest]);

  useEffect(() => {
    if (Object.values(valuesFormReservationUser).some((x) => x !== "")) {
      setTabsDisabled({
        ...tabsDisabled,
        two: true,
      });
    } else {
      setTabsDisabled({
        ...tabsDisabled,
        two: false,
      });
    }
  }, [valuesFormReservationUser]);

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={activeTabReservation}>
        <Box>
          <TabsCustom
            theme={theme}
            onChange={handleChangeTab}
            aria-label="lab API tabs example"
          >
            <Tab
              label="Como invitado"
              value="2"
              disabled={tabsDisabled["two"]}
            />
            <Tab label="Con cuenta" value="1" disabled={tabsDisabled["one"]} />
          </TabsCustom>
        </Box>
        <TabPanel value="1">
          <FormLogin xs={12} sm={6} />
        </TabPanel>
        <TabPanel value="2">
          <FormWaitListGuest />
        </TabPanel>
      </TabContext>
    </Box>
  );
}
